import { render, staticRenderFns } from "./ExtrusionDeliveryView.vue?vue&type=template&id=0f63f27c&scoped=true"
import script from "./ExtrusionDeliveryView.vue?vue&type=script&lang=js"
export * from "./ExtrusionDeliveryView.vue?vue&type=script&lang=js"
import style0 from "./ExtrusionDeliveryView.vue?vue&type=style&index=0&id=0f63f27c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63f27c",
  null
  
)

export default component.exports